
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class QuestionReplyDtoModel extends Model<QuestionReplyDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'orderId', type: 'string' },
		{ name: 'orderIds', type: 'string[]', isArray: true },
		{ name: 'orderLineId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'replyData', type: 'string' },
		{ name: 'questionnaireId', type: 'string' },
		{ name: 'questionTag', type: 'string' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public orderId?: string;
	public orderIds: string[];
	public orderLineId?: string;
	public taskflowId?: string;
	public replyData: string;
	public questionnaireId?: string;
	public questionTag: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.orderId = undefined;
		this.orderIds = [];
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		this.replyData = '';
		this.questionnaireId = undefined;
		this.questionTag = '';
		
	}
	getProperties(){
		return QuestionReplyDtoModel.classProperties;
	}
}

